// Module système : Bannière d'état de l'API
import React from 'react';
import { useSystemModules } from '../../G&CSCM/Core/SystemModulesContext';

const ApiStatusBanner: React.FC = () => {
    const { apiStatus } = useSystemModules();
    const [dismissed, setDismissed] = React.useState(false);

    // Ne rien afficher si l'API est en ligne ou si l'utilisateur a fermé
    if (apiStatus.isOnline || dismissed) {
        return null;
    }

    return (
        <div
            className="api-status-banner"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                backgroundColor: '#ff9800',
                color: 'white',
                padding: '12px 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                zIndex: 10000,
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                fontFamily: 'system-ui, sans-serif'
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '20px' }}>⚠️</span>
                <div>
                    <strong>Mode hors ligne</strong>
                    <p style={{ margin: '4px 0 0 0', fontSize: '14px', opacity: 0.9 }}>
                        Les données affichées peuvent être erronées. 
                        La connexion à l'API n'est pas disponible.
                    </p>
                </div>
            </div>
            <button
                onClick={() => setDismissed(true)}
                style={{
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 'bold'
                }}
            >
                Fermer
            </button>
        </div>
    );
};

export default ApiStatusBanner;


